export default __webpack_public_path__ + "static/media/cam_edu_logo.e3fbf876.png";